import React, { useEffect, useState, useRef } from 'react'
import { useAppData } from '../../../../../../context/AppDataContext';
import { Autocomplete, TextField } from '@mui/material';


function SelectInventory({callBack, options, selectedInventory,setSelectedInventory}) {

  const {getInventoryList,getInventoryDD, productList, getAppDataById} = useAppData();

  const focusInputRef = useRef(null);
    useEffect(() => {
      const timer = setTimeout(() => {
        if (focusInputRef.current) {
          focusInputRef.current.focus();
        }
      }, 100); // Gives the modal animation a brief moment to settle
  
      return () => clearTimeout(timer);
  }, []);

  

  
  

  return (

    <div className='row'>
      <div className='col-md-6'>
        <Autocomplete
            options={options}
            onChange={(event, newValue) => {
                setSelectedInventory(newValue);
            }}
            getOptionLabel={(inventory) => getAppDataById(productList, inventory.productId).title+" [Available "+inventory.qty+"]"  }
            forcePopupIcon={false}
            className='bg-white'
            value={selectedInventory}
            renderInput={(params) => <TextField {...params} inputRef={focusInputRef} size="small" label="Select Inventory" variant="standard" /> } 
        />
      </div>
      
    </div>

  )
}

export default SelectInventory